import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/identity';

function validateIdentitySuccess(state, action) {
  const { code, message, errorDetail } = action.payload;
  state.validateIdentity = {
    success: true,
    error: false,
    errorDetail,
    code,
    message,
  };
}

function validateIdentityError(state, action) {
  const { code, message } = action.payload;
  state.validateIdentity = {
    success: false,
    error: true,
    code,
    message,
    errorDetail: null,
  };
}

const validateIdentity = createAction('validateIdentity');

const identityReducer = createSlice({
  name: 'identity',
  initialState,
  reducers: {
    validateIdentitySuccess,
    validateIdentityError,
  },
});

export const identityActions = {
  ...identityReducer.actions,
  validateIdentity,
};

export default identityReducer.reducer;
